import {
  Box,
  makeStyles,
  Typography,
  Tabs,
  Tab,
  Badge,
} from "@material-ui/core";
import React from "react";
import { Link } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SubjectPropertyCard from "./subjectPropertyCard";
import { useStore } from '@roc/client-portal-shared/hooks';
import { observer } from "mobx-react";
import { ComparablesSection } from "./comparablesSection";
import { capitalizeOnlyFirstLetter } from "@roc/feature-comp-tool";
import CompareSelection from "./compareSelection";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    padding: "2rem"
  },
  backLink: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "theme.palette.primary.main",
    textDecoration: "none",
    fontWeight: "bold",
    fontSize: "1rem",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  tabs: {
    "& .MuiTabs-flexContainer": {
      display: "flex", // Use flexbox
      justifyContent: "flex-end",
    },
    "& .MuiTab-root": {
      "&:hover": {
        color: theme.palette.primary.dark, // Darker primary color on hover
      },
      backgroundColor: "transparent",
    },
    "& .Mui-selected": {
      color: theme.palette.primary.main, // Active tab color
      backgroundColor: "transparent",
    },
  },
  mapStyles: {
    position: `relative`,
    width: `100%`,
    height: `100%`,
  }
}));

const CompareScreen = observer(() => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const { compToolStoreV2: compToolStore } = useStore();


  const handleChange = (_, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      compToolStore.setRentalComps(false);
    }
    if (newValue === 1) {
      compToolStore.setRentalComps(true);
    }
  };

  const handleBackToSearch = () => {
    compToolStore.reset();
  }

  const handleBackToSearchResults = () => {
    if (compToolStore.rentalComps) {
      setValue(1);
    } else {
      setValue(0);
    }
  }

  const subjectProperty: any = compToolStore.subjectProperty.data;

  const selectedPropertiesCount = compToolStore.selectedCompareProperties?.length || 0;

  const compareTabDisabled = selectedPropertiesCount === 0;

  return (
    <>
      {value !== 2 && (<Box display="flex" flexDirection="column" gridGap={16} className={classes.root}>
        <Typography variant="h4"> Comparable Analytics Tool</Typography>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" gridGap="10px">
            <Link component="button" className={classes.backLink} onClick={handleBackToSearch}>
              <ArrowBackIosIcon />
              Back to Search /
            </Link>
            <Typography variant="body1" color="primary">
              {capitalizeOnlyFirstLetter(subjectProperty.address)}
            </Typography>
          </Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
            className={classes.tabs}
            indicatorColor="primary"
          >
            <Tab id="salesComparableTab" key="salesComparableTab" label="SALES COMPARABLE" />
            <Tab id="rentalComparableTab" key="rentalComparableTab" label="RENTAL COMPARABLE" />
            <Tab
              id="compareSelectedTab"
              key="compareSelectedTab"
              label={
                <Badge
                  color="secondary"
                  badgeContent={selectedPropertiesCount > 0 ? selectedPropertiesCount : null}
                >
                  COMPARE SELECTED
                </Badge>
              }
              disabled={compareTabDisabled} />
          </Tabs>
        </Box>
        <SubjectPropertyCard />
        <ComparablesSection />
      </Box>)}

      {value === 2 && (
        <CompareSelection onBack={handleBackToSearchResults} />
      )}
    </>
  );
});

export default CompareScreen;
